<template>
  <a-modal
    title="记账凭证"
    :width="1120"
    :visible="visible"
    :footer="null"
    :maskClosable="false"
    @cancel="close">
    <div v-if="visible" class="voucher-editor" ref="voucherEditorRef">
      <!-- 顶部按钮 -->
      <div class="h-row-flex top-buttons" style="margin-bottom: 12px;">
        <div class="h-col">
          <button v-if="isEdit" type="button" class="h-btn h-btn-primary" :disabled="saving" @click="save(false)">
            <span>保存并新增</span>
          </button>
          <button v-if="isEdit" type="button" class="h-btn h-btn-primary" :disabled="saving" style="margin-left:8px" @click="save(true)">
            <span>保存</span>
          </button>
        </div>
      </div>

      <!-- 凭证头部信息 -->
      <div class="h-row-flex voucher-head">
        <a-select v-model="form.voucherWordId" style="min-width:70px;width:70px">
          <a-select-option v-for="w in voucherWords" :key="w.id" :value="w.id">{{ w.word }}</a-select-option>
        </a-select>
        <span style="min-width:90px;display:inline-block;text-align:center;">{{ form.voucherNoNum ? form.voucherNoNum + ' 号' : '自动' }}</span>
        <span style="margin-left:12px;">日期：</span>
        <a-date-picker v-model="form.voucherDate" format="YYYY-MM-DD" style="width:140px" />
        <span style="margin-left:12px;">备注：</span>
        <a-input v-model="form.summary" placeholder="请输入备注内容" style="width:300px" />
      </div>

      <div class="voucher-table bg-white-color">
        <table cellspacing="0" cellpadding="0">
          <thead>
            <tr class="bg-white-color">
              <td class="td-zhaoyao-head" style="font-weight:bold">摘要</td>
              <td class="td-kemu-head" style="font-weight:bold">会计科目</td>
              <td class="td-money-head">
                <div style="font-weight:bold">借方金额</div>
                <div class="moneyUnit">
                  <span>亿</span><span>千</span><span>百</span><span>十</span><span>万</span><span>千</span><span>百</span><span>十</span><span>元</span><span>角</span><span class="last">分</span>
                </div>
              </td>
              <td class="td-money-head tdLast">
                <div style="font-weight:bold">贷方金额</div>
                <div class="moneyUnit">
                  <span>亿</span><span>千</span><span>百</span><span>十</span><span>万</span><span>千</span><span>百</span><span>十</span><span>元</span><span>角</span><span class="last">分</span>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(it, index) in form.items" :key="it.k" class="trDetails">
              <td class="tdZhaoyao tdInput" style="position:relative;">
                <input v-if="isEdit"
                       class="cell-input"
                       v-model="it.summary"
                       placeholder="输入摘要"
                       @focus="openSummaryDrop(it,index,$event)"
                       @blur="handleSummaryBlur(it)"
                />
                <div v-else class="cell-click-display">{{ it.summary || '' }}</div>
                <i v-if="isEdit" class="row-icon row-add" @click="insertRow(index)"><a-icon type="plus-circle" /></i>
              </td>
              <td class="tdKemu tdInput" style="position:relative;">
                <input v-if="isEdit"
                       class="cell-input"
                       v-model="it._subjectDisplayText"
                       placeholder="输入科目编码/名称"
                       @focus="openSubjectDrop(it,index,$event)"
                       @blur="handleSubjectBlur(it)"
                       @input="filterSubject(it)"
                />
                <div v-else class="display subject-display">{{ subjectText(it) }}</div>
              </td>
              <td class="tdJieFang tdInput">
                <div v-if="it.editField !== 'debit'" class="display displayMoney" :class="{ 'amount-negative': Number(it.debitAmount) < 0 }" @click="startEdit(it, 'debit')">
                  <span v-for="(d, i) in amountDigits(it.debitAmount)" :key="i" class="money-digit" :class="{ last: i === 10 }">{{ d }}</span>
                </div>
                <input v-else v-focus type="text" class="money-edit" v-model="it.debitAmount" @blur="endEdit(it, 'debit')" @keyup.enter="endEdit(it, 'debit')" @click.stop />
              </td>
              <td class="tdLast tdDaiFang tdInput" style="position:relative">
                <div v-if="it.editField !== 'credit'" class="display displayMoney" :class="{ 'amount-negative': Number(it.creditAmount) < 0 }" @click="startEdit(it, 'credit')">
                  <span v-for="(d, i) in amountDigits(it.creditAmount)" :key="i" class="money-digit" :class="{ last: i === 10 }">{{ d }}</span>
                </div>
                <input v-else v-focus type="text" class="money-edit" v-model="it.creditAmount" @blur="endEdit(it, 'credit')" @keyup.enter="endEdit(it, 'credit')" @click.stop />
                <i v-if="isEdit && form.items.length > 1" class="row-icon row-del" @click="delRow(index)"><a-icon type="minus-circle" /></i>
              </td>
            </tr>
            <tr class="trDetails total">
              <td colspan="2" class="spTotal padding-left">合计:</td>
              <td>
                <div class="display displayMoney" :class="{ 'amount-negative': debitTotal < 0 }"><span v-for="(d, i) in amountDigits(debitTotal)" :key="i" class="money-digit" :class="{ last: i === 10 }">{{ d }}</span></div>
              </td>
              <td class="tdLast">
                <div class="display displayMoney" :class="{ 'amount-negative': creditTotal < 0 }"><span v-for="(d, i) in amountDigits(creditTotal)" :key="i" class="money-digit" :class="{ last: i === 10 }">{{ d }}</span></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="voucher-footer">
        <div style="text-align:right;color:#999;padding-right:20px;">制单人：{{ makerName || '当前用户' }}</div>
      </div>
    </div>

    <!--浮层放到a-modal直接子节点 fixed定位 -->
    <div v-if="dropState.showSummary || dropState.showSubject"
         class="drop-panel-root"
         :style="dropState.panelStyle"
         @mousedown.prevent>
      <template v-if="dropState.showSummary">
        <div v-for="opt in summaryFilterList" :key="opt" class="drop-item" @click="selectSummaryItem(dropState.currentRowItem,opt)">
          {{opt}}
        </div>
      </template>
      <template v-if="dropState.showSubject">
        <div v-for="s in subjectFilterList" :key="s.id" class="drop-item" @click="selectSubjectItem(dropState.currentRowItem,s)">
          {{s.subjectCode}} {{s.subjectName}}
        </div>
      </template>
    </div>

    <!-- 辅助核算弹窗保留 -->
    <a-modal title="辅助核算" :width="460" :visible="auxVisible" :maskClosable="false" @ok="confirmAux" @cancel="auxVisible = false">
      <a-form layout="horizontal">
        <a-form-item v-for="c in auxDialog.categories" :key="c.id" :label="c.name">
          <a-select v-model="auxDialog.values[c.id]" placeholder="请选择" style="width:100%">
            <a-select-option v-for="d in auxDialog.details[c.id]" :key="d.id" :value="d.id">{{ d.name }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-modal>
</template>

<script>
import { voucherGet, voucherSave, subjectLeafList, auxiliaryCategoryList, auxiliaryDetailList, voucherWordList } from './api'
import { getDicts } from '@/api/api'
import moment from 'moment'

export default {
  name: 'VoucherEditor',
  directives: {
    focus: { inserted(el) { el.focus() } }
  },
  props: {
    visible: { type: Boolean, default: false },
    mode: { type: String, default: 'add' },
    accountSetId: { type: Number, default: null },
    period: { type: String, default: '' },
    voucherId: { type: Number, default: null }
  },
  data() {
    return {
      saving: false,
      voucherWords: [],
      leafSubjects: [],
      auxCategories: [],
      summaryOptions: [],
      auxVisible: false,
      auxDialog: { categories: [], values: {}, details: {}, item: null },
      dropState:{
        showSummary:false,
        showSubject:false,
        curItemKey:null,
        blurTimer:null,
        currentRowItem: null,
        panelStyle: { top:'0px', left:'0px', width:'200px' }
      },
      summaryFilterList:[],
      subjectFilterList:[],
      modalBody: null,
      form: {
        voucherWordId: undefined,
        voucherNoNum: undefined,
        voucherNoStr: '',
        voucherDate: moment(),
        summary: '',
        items: []
      }
    }
  },
  computed: {
    isEdit() { return this.mode !== 'view' },
    debitTotal() { return (this.form.items || []).reduce(function(s, i) { return s + (Number(i.debitAmount) || 0); }, 0) },
    creditTotal() { return (this.form.items || []).reduce(function(s, i) { return s + (Number(i.creditAmount) || 0); }, 0) },
    makerName() {
      const u = this.$store.getters.userInfo || {}
      return u.realname || u.username || ''
    }
  },
  watch: {
    visible(v) {
      if (v) {
        this.reset()
        this.$nextTick(()=>{
          // 去掉 ?. 可选链，兼容旧babel
          const refEl = this.$refs.voucherEditorRef
          if(refEl && refEl.$el){
            var body = refEl.$el.closest('.ant-modal-body')
            if(body){
              this.modalBody = body
              this.modalBody.addEventListener('scroll',this.onModalScroll)
            }
          }
        })
      }else{
        this.clearDropTimer()
        this.dropState.showSummary = false
        this.dropState.showSubject = false
        if(this.modalBody){
          this.modalBody.removeEventListener('scroll',this.onModalScroll)
          this.modalBody = null
        }
      }
    }
  },
  methods: {
    onModalScroll(){
      this.clearDropTimer()
      this.dropState.showSummary = false
      this.dropState.showSubject = false
    },
    close() { this.$emit('update:visible', false) },
    reset() {
      this.clearDropTimer();
      this.dropState.showSummary = false;
      this.dropState.showSubject = false;
      this.dropState.curItemKey = null;
      this.dropState.currentRowItem = null;

      this.form = { voucherWordId: undefined, voucherNoNum: undefined, voucherNoStr: '', voucherDate: moment(), summary: '', items: [] }
      this.loadBase()
      if ((this.mode === 'edit' || this.mode === 'view') && this.voucherId) {
        voucherGet({ id: this.voucherId }).then((res) => {
          if (!res || !res.success || !res.data) { this.$message.error('加载凭证失败'); return }
          const v = res.data
          const no = v.voucherNo || ''
          const idx = no.lastIndexOf('-')
          this.form = {
            id: v.id,
            voucherNoNum: idx >= 0 ? (Number(no.substring(idx + 1)) || undefined) : undefined,
            voucherNoStr: v.voucherNo || '',
            voucherDate: v.voucherDate ? moment(String(v.voucherDate)) : moment(),
            summary: '',
            items: (v.items || []).map(it => ({
              k: 'e' + it.id + Math.random(),
              subjectId: it.subjectId,
              summary: it.summary || '',
              debitAmount: it.debitAmount,
              creditAmount: it.creditAmount,
              editField: null,
              auxTypes: [],
              auxItems: (it.auxItems || []).map(a => ({ categoryId: a.categoryId, detailId: a.detailId })),
              _subjectDisplayText:''
            }))
          }
          this.form.items.forEach(it => {
            const s = this.leafSubjects.find(x => x.id === it.subjectId)
            it.auxTypes = (s && s.auxiliaryTypes) ? s.auxiliaryTypes.split(',') : []
            if(s){
              it._subjectDisplayText = s.subjectCode + ' ' + s.subjectName
            }
            const names = this.auxCategories.filter(c => (it.auxItems || []).some(a => a.categoryId === c.id)).map(c => c.name)
            const details = (it.auxItems || []).map(a => {
              const cate = this.auxCategories.find(c => c.id === a.categoryId)
              const d = (this.auxDialog.details[a.categoryId] || []).find(x => x.id === a.detailId)
              return d ? d.name : (cate ? cate.name : '')
            }).filter(Boolean).join(' ')
            it.auxSummary = [names.join(','), details].filter(Boolean).join(' ')
          })
        })
      } else {
        for (let i = 0; i < 4; i++) this.addRow()
      }
    },
    loadBase() {
      voucherWordList({ accountSetId: this.accountSetId }).then((res) => {
        if (res && res.success) {
          this.voucherWords = res.data || []
          if (!this.form.voucherWordId && this.voucherWords.length) this.form.voucherWordId = this.voucherWords[0].id
        }
      })
      subjectLeafList({ accountSetId: this.accountSetId }).then((res) => {
        if (res && res.success) {
          this.leafSubjects = res.data || []
        }
      })
      auxiliaryCategoryList({ accountSetId: this.accountSetId }).then((res) => { if (res && res.success) this.auxCategories = res.data || [] })
      getDicts('voucher_summary').then((res) => {
        if (res && res.success && res.data) this.summaryOptions = res.data.map(d => d.dictLabel).filter(Boolean)
      }).catch(() => { this.summaryOptions = [] })
    },
    newRow() {
      return {
        k: 'it' + Date.now() + Math.random(),
        subjectId: undefined,
        debitAmount: undefined,
        creditAmount: undefined,
        summary: undefined,
        editField: null,
        auxTypes: [],
        auxItems: [],
        auxSummary: '',
        _subjectDisplayText: ''
      }
    },
    addRow() { this.form.items.push(this.newRow()) },
    insertRow(index) { this.form.items.splice(index + 1, 0, this.newRow()) },
    delRow(index) {
      if (this.form.items.length <= 1) return
      this.form.items.splice(index, 1)
    },
    amountDigits(amount) {
      const n = Number(amount) || 0
      const neg = n < 0
      const v = Math.round(Math.abs(n) * 100)
      const s = v.toString().padStart(11, '0')
      const out = []
      let started = false
      for (const ch of s.slice(0, 9)) {
        if (!started && ch === '0') out.push('')
        else { started = true; out.push(ch) }
      }
      out.push(s.slice(9, 10), s.slice(10, 11))
      if (neg) {
        const idx = out.findIndex(x => x !== '')
        if (idx === 0) out[0] = '-'
        else if (idx > 0) out[idx - 1] = '-'
      }
      return out
    },
    startEdit(item, field) {
      if (!this.isEdit) return
      item.editField = field
    },
    endEdit(item, field) {
      const v = parseFloat(item[field])
      item[field] = isNaN(v) ? 0 : Math.round(v * 100) / 100
      item.editField = null
    },
    subjectText(it) {
      const s = this.leafSubjects.find(x => x.id === it.subjectId)
      if (!s) return ''
      return (s.subjectCode || '') + ' ' + s.subjectName + (s.auxiliaryTypes ? '_' + s.auxiliaryTypes : '') + (it.auxSummary ? ' ' + it.auxSummary : '')
    },

    getDropPanelPos(inputDom){
      const rect = inputDom.getBoundingClientRect();
      const panelMaxHeight = 220;
      const spaceDown = window.innerHeight - rect.bottom;
      const style = {
        left: rect.left + 'px',
        width: rect.width + 'px',
      }
      if(spaceDown >= panelMaxHeight){
        style.top = rect.bottom + 'px';
        style.bottom = 'auto';
      }else{
        style.bottom = (window.innerHeight - rect.top) + 'px';
        style.top = 'auto';
      }
      return style;
    },

    openSummaryDrop(item,index,event){
      this.clearDropTimer();
      this.dropState.showSubject = false;
      this.dropState.showSummary = true;
      this.dropState.curItemKey = item.k;
      this.dropState.currentRowItem = item;
      this.summaryFilterList = [...this.summaryOptions];
      this.dropState.panelStyle = this.getDropPanelPos(event.target);
    },
    handleSummaryBlur(){
      this.clearDropTimer();
      this.dropState.blurTimer = setTimeout(()=>{
        this.dropState.showSummary = false;
        this.dropState.curItemKey = null;
        this.dropState.currentRowItem = null;
      },220)
    },
    selectSummaryItem(item,opt){
      this.clearDropTimer();
      item.summary = opt;
      this.dropState.showSummary = false;
      this.dropState.curItemKey = null;
      this.dropState.currentRowItem = null;
    },

    openSubjectDrop(item,index,event){
      this.clearDropTimer();
      this.dropState.showSummary = false;
      this.dropState.showSubject = true;
      this.dropState.curItemKey = item.k;
      this.dropState.currentRowItem = item;
      this.subjectFilterList = [...this.leafSubjects];
      this.dropState.panelStyle = this.getDropPanelPos(event.target);
    },
    filterSubject(item){
      const kw = (item._subjectDisplayText||'').toLowerCase().trim()
      if(!kw){
        this.subjectFilterList = [...this.leafSubjects]
      }else{
        this.subjectFilterList = this.leafSubjects.filter(function(s){
          return s.subjectCode.toLowerCase().indexOf(kw) > -1 || s.subjectName.toLowerCase().indexOf(kw) > -1
        })
      }
    },
    handleSubjectBlur(){
      this.clearDropTimer();
      this.dropState.blurTimer = setTimeout(()=>{
        this.dropState.showSubject = false;
        this.dropState.curItemKey = null;
        this.dropState.currentRowItem = null;
      },220)
    },
    selectSubjectItem(item,s){
      this.clearDropTimer();
      item.subjectId = s.id;
      item._subjectDisplayText = s.subjectCode + ' ' + s.subjectName;
      item.auxTypes = (s && s.auxiliaryTypes) ? s.auxiliaryTypes.split(',') : []
      item.auxItems = []
      item.auxSummary = ''
      this.dropState.showSubject = false;
      this.dropState.curItemKey = null;
      this.dropState.currentRowItem = null;
      if (item.auxTypes && item.auxTypes.length) this.openAuxDialog(item)
    },
    clearDropTimer(){
      if(this.dropState.blurTimer){
        clearTimeout(this.dropState.blurTimer)
        this.dropState.blurTimer = null
      }
    },

    openAuxDialog(item) {
      if (!this.isEdit) return
      const categories = (item.auxTypes || []).map(name => this.auxCategories.find(c => c.name === name)).filter(c => c)
      if (!categories.length) return
      const details = {}
      categories.forEach(c => {
        details[c.id] = []
        auxiliaryDetailList({ categoryId: c.id }).then((res) => {
          if (res && res.success) this.$set(details, c.id, res.data || [])
        })
      })
      const values = {}
      categories.forEach(c => {
        const found = (item.auxItems || []).find(a => a.categoryId === c.id)
        values[c.id] = found ? found.detailId : undefined
      })
      this.auxDialog = { categories, values, details, item }
      this.auxVisible = true
    },
    confirmAux() {
      const item = this.auxDialog.item
      if (!item) return
      const missing = this.auxDialog.categories.find(c => this.auxDialog.values[c.id] == null)
      if (missing) {
        this.$message.warning(`请选择「${missing.name}」`)
        return
      }
      this.$set(item, 'auxItems', this.auxDialog.categories.map(c => ({ categoryId: c.id, detailId: this.auxDialog.values[c.id] })))
      const names = this.auxDialog.categories.map(c => c.name).join(',')
      const details = this.auxDialog.categories.map(c => {
        const d = (this.auxDialog.details[c.id] || []).find(x => x.id === this.auxDialog.values[c.id])
        return d ? d.name : ''
      }).filter(Boolean).join(' ')
      this.$set(item, 'auxSummary', [names, details].filter(Boolean).join(' '))
      this.auxVisible = false
    },
    save(closeAfter) {
      const filledItems = this.form.items.filter(i =>
        i.subjectId || (Number(i.debitAmount) || 0) !== 0 || (Number(i.creditAmount) || 0) !== 0 || i.summary)
      for (const i of filledItems) {
        if (!i.subjectId) {
          this.$message.warning('存在未选择会计科目的分录')
          return
        }
        const debit = Number(i.debitAmount) || 0
        const credit = Number(i.creditAmount) || 0
        if (debit === 0 && credit === 0) {
          this.$message.warning('存在金额为 0 的分录')
          return
        }
      }
      const items = filledItems.map(i => ({
        subjectId: i.subjectId,
        summary: i.summary || this.form.summary,
        debitAmount: Number(i.debitAmount) || 0,
        creditAmount: Number(i.creditAmount) || 0,
        auxItems: (i.auxItems || []).filter(a => a.categoryId && a.detailId)
      }))
      if (!items.length) {
        this.$message.warning('请至少录入一条分录')
        return
      }
      const d = this.debitTotal
      const c = this.creditTotal
      if (d === 0) {
        this.$message.warning('凭证金额不能全部为 0')
        return
      }
      if (Math.abs(d - c) > 0.0001) {
        this.$message.warning(`借贷不平衡：借方=${d} 贷方=${c}`)
        return
      }
      const voucherNo = this.form.id ? this.form.voucherNoStr : null
      this.saving = true
      voucherSave({
        accountSetId: this.accountSetId,
        id: this.form.id,
        voucherNo,
        voucherDate: this.form.voucherDate ? this.form.voucherDate.format('YYYY-MM-DD') : '',
        period: this.period,
        items
      }).then(res => {
        if (res && res.success) {
          this.$message.success('保存成功')
          this.$emit('saved')
          if (closeAfter) {
            this.close()
          } else {
            this.form = { voucherWordId: this.form.voucherWordId, voucherNoNum: undefined, voucherNoStr: '', voucherDate: this.form.voucherDate, summary: '', items: [] }
            for (let i = 0; i < 4; i++) this.addRow()
          }
        } else {
          this.$message.error(res.message || '保存失败')
        }
        this.saving = false
      }).catch(() => {
        this.saving = false
        this.$message.error('保存失败')
      })
    }
  }
}
</script>

<style scoped>
.h-row-flex { display: flex; flex-direction: row; flex-wrap: wrap; }
.h-col { flex: 0 0 auto; }
.voucher-head { align-items: center; margin-bottom: 10px; }
.voucher-head > * { margin-right: 6px; }
.h-btn { outline: none; padding: 8px 15px; font-family: inherit; display: inline-block; border-radius: 2px; color: inherit; font-size: 13px; line-height: 1; box-sizing: border-box; cursor: pointer; transition: all .2s; border: 1px solid #d3d3d3; box-shadow: 0 1px 1px 0 #eee; background-color: #fff; }
.h-btn[disabled] { cursor: not-allowed; background-color: #f5f5f5; border-color: #d3d3d3; color: #999; }
.h-btn.h-btn-primary { background: rgb(24,144,255); border-color: rgb(24,144,255); color: #fff; }

.voucher-table { position: relative; font-size: 12px; width: 100%; padding: 10px 24px; }
.voucher-table table {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}
.voucher-table .tdLast { border-right: 1px solid #dadada; }

.td-zhaoyao-head, .tdZhaoyao { width: 208px; }
.td-kemu-head, .tdKemu { width: 308px; }
.td-money-head, .tdJieFang, .tdDaiFang { width: 221px; }

.voucher-table table thead td,
.voucher-table table tbody td {
  border-left: 1px solid #dadada;
  border-top: 1px solid #dadada;
  border-bottom: 1px solid #dadada;
  padding: 0;
  vertical-align: middle;
  height: 60px;
  box-sizing: border-box;
}
.voucher-table table thead tr td {
  text-align: center;
  line-height: 30px;
}

.cell-input{
  width:100%;
  height:60px;
  border:none;
  outline:none;
  padding:0 6px;
  font-size:13px;
  background:transparent;
  box-sizing:border-box;
}
.cell-input:focus{
  background:#fff;
}

.drop-panel-root{
  position: fixed;
  max-height:220px;
  min-height:0;
  overflow-y:auto;
  overflow-x:hidden;
  background:#ffffff;
  border:1px solid #ccc;
  z-index:1200 !important;
}
.drop-item{
  padding:6px 8px;
  cursor:pointer;
  font-size:13px;
}
.drop-item:hover{
  background:#e8f4ff;
}

.voucher-table .moneyUnit {
  border-top: 1px solid #dadada;
  height: 30px;
  width: 221px;
  margin: 0 auto;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANsAAAAUCAMAAAAz47gTAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA9QTFRF6enpp9n17bm55ubmvJyc+JGLrgAAAAV0Uk5T/////wD7tg5TAAAAQklEQVR42uzPsQ0AIAwDsBb4/2YOYCkCqYszRsngWGdmscum7yju4qHLpu/47GBjY2NjY2NjY2NjY2NjY7u3bQEGAIG/Qbbiioa2AAAAAElFTkSuQmCC);
  display: grid;
  grid-template-columns: repeat(11, 19px);
  gap:1px;
}
.voucher-table .moneyUnit span {
  height:100%;
  background-color: #fff;
  text-align: center;
  font-size: 12px;
  line-height: 30px;
}

.voucher-table .body .trDetails .spTotal {
  text-align: left;
  vertical-align: middle;
  font-weight: 700;
  padding-left: 6px;
}

.cell-click-display {
  height: 60px;
  line-height: 60px;
  padding:0 6px;
  cursor: pointer;
  text-align:left;
  box-sizing: border-box;
  white-space: nowrap;
  overflow:hidden;
  text-overflow: ellipsis;
}
.cell-click-display:hover {
  background-color:#f7f8fa;
}

.voucher-table .displayMoney {
  width: 221px;
  height: 60px;
  margin: 0 auto;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANsAAAAUCAMAAAAz47gTAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA9QTFRF6enpp9n17bm55ubmvJyc+JGLrgAAAAV0Uk5T/////wD7tg5TAAAAQklEQVR42uzPsQ0AIAwDsBb4/2YOYCkCqYszRsngWGdmscum7yju4qHLpu/47GBjY2NjY2NjY2NjY2NjY7u3bQEGAIG/Qbbiioa2AAAAAElFTkSuQmCC);
  font-weight: 700;
  font-size: 14px;
  font-family: tahoma, serif;
  display: grid;
  grid-template-columns: repeat(11,19px);
  gap:1px;
}
.displayMoney .money-digit {
  height: 100%;
  background-color: #fff;
  text-align: center;
  line-height: 60px;
}
.displayMoney.amount-negative { color: #f5222d; }

.voucher-table .subject-display { font-weight: 700; }
.money-edit {
  width: 100%;
  height: 60px;
  border: 0;
  outline: 0;
  text-align: right;
  padding: 0 4px;
  font-size: 14px;
  box-sizing: border-box;
  background: #fff;
}
.bg-white-color { background-color: #fff !important; }

.row-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  cursor: pointer;
  opacity: 0;
  transition: opacity .2s;
  color: #1890ff;
  z-index: 10;
}
.row-add { left: -26px; }
.row-del { right: -26px; }
.trDetails { position: relative; }
.voucher-table .trDetails:hover .row-icon { opacity: 1; }
</style>